import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const accentColor = '#d4af37';

const faqs = [
  {
    q: 'Who is Venkat Swaroop?',
    a: "Venkat Swaroop (Venkata Jyothi Swaroop Vemparala) is a global business leader serving as Director of Operations at TekWissen Group. With over 15 years of experience, he leads global delivery operations and talent acquisition, has served 100+ Fortune 500 clients, and led teams of 1000+ professionals across the US, UK, EMEA, India, Australia and Canada. He is also the founder of RecruiterIQ."
  },
  {
    q: 'What is Venkat Swaroop known for?',
    a: "He is recognized for operational leadership and global talent acquisition, building and scaling high-performing delivery teams, and driving business transformation. He is an award-winning leader, a mentor, and a builder of recruitment technology and AI initiatives, including founding RecruiterIQ."
  },
  {
    q: 'What is his current role?',
    a: "Venkat Swaroop is the Director of Operations at TekWissen Group (since June 2026), having previously served as Associate Director. In this role he leads global delivery operations, organizational strategy, and operational excellence across multiple geographies."
  },
  {
    q: 'What is RecruiterIQ?',
    a: "RecruiterIQ (therecruiteriq.com) is a recruitment industry platform founded by Venkat Swaroop. It reflects his focus on combining talent acquisition expertise with technology to support the recruiting community."
  },
  {
    q: 'Which industries does Venkat Swaroop work in?',
    a: "He has led talent acquisition and delivery across Information Technology, Engineering, Healthcare & Life Sciences, Pharmaceutical, Finance, and other professional sectors, serving Fortune 500 and enterprise clients."
  },
  {
    q: 'What awards and recognition has he received?',
    a: "His recognitions include Top 100 Influencing Leaders (Fox Story India, 2025), Top Staffing Leaders to Watch (Candidate.ly, 2024 & 2025), Top 10 Growing Influential Leaders (FoxStory, 2023), 40 Under 40 Dynamic Leaders (HRAI, 2023), Top 100 Influential Leaders (Leadify India, 2023), Top 100 Great People Managers (Forbes India, 2022), and World's Best Recruiters (RChilli, 2021)."
  },
  {
    q: 'Which regions and markets does he operate across?',
    a: "He has managed global delivery operations across the United States, Canada, United Kingdom, EMEA, India, and Australia, partnering with Fortune 500 clients in multiple regions."
  },
  {
    q: 'What is his leadership philosophy?',
    a: "His leadership centers on empowerment, collaboration, and continuous growth — fostering environments where individuals and organizations thrive together, while combining operational excellence with technology-driven innovation."
  },
  {
    q: 'What company does Venkat Swaroop work for?',
    a: "He works at TekWissen Group, a global technology and talent solutions company, where he serves as Director of Operations."
  },
  {
    q: 'How can I connect with Venkat Swaroop?',
    a: "You can connect with Venkat Swaroop on LinkedIn (linkedin.com/in/venkatjyothiswaroop) or through the contact section of this website."
  }
];

const FAQPage = () => {
  useEffect(() => {
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': 'https://venkatswaroop.in/faq#faqpage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a }
      }))
    };
    let script = document.getElementById('ld-faq');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'ld-faq';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);
    return () => {
      const s = document.getElementById('ld-faq');
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="faq-page">
      <SEOHead
        title="Frequently Asked Questions | Venkat Swaroop"
        description="Answers to common questions about Venkat Swaroop - Director of Operations, Global Talent Acquisition Leader, and founder of RecruiterIQ."
        url="https://venkatswaroop.in/faq"
      />
      <Header />

      <section className="bg-[#1a2332] pt-32 pb-16 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="mb-4 font-serif text-4xl font-bold sm:text-5xl">Frequently Asked Questions</h1>
          <div className="mx-auto h-1 w-24 rounded" style={{ backgroundColor: accentColor }}></div>
          <p className="mx-auto mt-6 max-w-2xl text-base text-white/80 md:text-lg">
            Everything you need to know about Venkat Swaroop — his work, recognition, and RecruiterIQ.
          </p>
        </div>
      </section>

      <section className="py-16" style={{ color: '#1a2332' }}>
        <div className="container mx-auto max-w-3xl px-6">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-serif text-lg font-semibold hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed opacity-90">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQPage;
